import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppConfigService } from '../../../services/config/app-config.service';
import { TokenStorageService } from '../../../services/storage/token-storage.service';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
    selector: 'app-fix-api',
    templateUrl: './fix-api.component.html',
    styleUrls: ['./fix-api.component.css'],
    standalone: false
})
export class FixApiComponent implements OnInit, OnDestroy {

  fixProjectId: string | undefined;
  env: string | null;
  fixIframeUrl: SafeResourceUrl | null = null;

  private messageListener!: (event: MessageEvent) => void;

  private readonly iframeOrigin = (() => {
    try {
      return new URL(environment.fixIframeUrl).origin;
    } catch {
      return window.location.origin;
    }
  })();

  constructor(
    appConfig: AppConfigService,
    private tokenStorageService: TokenStorageService,
    private sanitizer: DomSanitizer,
    private router: Router,
  ) {
    this.env = tokenStorageService.getUserEnv();
    if (this.env == 'asia') {
      this.fixProjectId = appConfig.getAsiaConfig?.fixProjectId;
    } else {
      this.fixProjectId = appConfig.getMenaConfig?.fixProjectId;
    }
  }

  ngOnInit(): void {
    this.fixIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.fixIframeUrl);

    this.messageListener = (event: MessageEvent) => {
      if (event.origin !== this.iframeOrigin) return;

      const data: any = event.data;

      // Handle error signals from Docusaurus (404 / 403)
      if (data && typeof data === 'object' && data.type === 'GTN_ERROR') {
        const code = data.code === 403 ? 403 : 404;
        this.router.navigate([`/${code}`]);
      }
    };

    window.addEventListener('message', this.messageListener, false);
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.messageListener, false);
  }
}
